import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "sonner";
import { useAuth } from "./context/AuthContext";

import Home from "./pages/Home";
import FindJobs from "./pages/FindJobs";
import AdminLogin from "./pages/AdminLogin";
import ScrollToTop from "./components/ScrollToTop";
import AdminPannel from "./pages/AdminPannel";
import Contact from "./pages/Contact";
import JobDetailsPage from "./components/JobDetailsPage";
import ResetPassword from "./pages/ResetPassword";
import Resume from "./pages/Resume";
import SuperAdminLogin from "./pages/SuperAdminLogin";
import SuperAdmin from "./pages/SuperAdmin";
import SuperAdminRoute from "./pages/SuperAdminRoute";
import CompanyApplicants from "./pages/CompanyApplicants";
import ViewJobApplicants from "./pages/ViewJobApplicants";
import BeOurPartner from "./components/BeOurPartner";
import NotFound from "./pages/NotFound";
import JobFair from "./pages/JobFair";
import JobFairDetails from "./pages/JobFairDetails";
//import Marquee from "./components/Marquee";

// DELHI JOBS
import JobsInDelhi from "./delhijobs/JobsInDelhi";
import Itjobsdelhi from "./delhijobs/Itjobsdelhi";
import Hrjobs from "./delhijobs/Hrjobs";
import Fresherjobs from "./delhijobs/Fresherjobs";
import Fulltimejobs from "./delhijobs/Fulltimejobs";
import Telecallerjobs from "./delhijobs/Telecallerjobs";
import DigitalMarketingJobs from "./delhijobs/DigitalMarketingJobs";
import TechnicalSupportJobs from "./delhijobs/TechnicalSupportJobs";
import AppDevelopmentJobs from "./delhijobs/AppDevelopmentJobs";
import WebDevelopmentJobs from "./delhijobs/WebDevelopmentJobs";
import SoftwareDevelopmentJobs from "./delhijobs/SoftwareDevelopmentJobs";

//NOIDA JOBS

import ItJobs from "./noidajobs/ItJobs";
import JobsInNoida from "./noidajobs/JobsInNoida";
import HRJobsNoida from "./noidajobs/HRJobsNoida";
import FresherJobsNoida from "./noidajobs/FresherJobsNoida";
import FullTimeJobNoida from "./noidajobs/FullTimeJobNoida";
import TelecallerJobsNoida from "./noidajobs/TelecallerJobsNoida";
import DigitalMarketingJobsNoida from "./noidajobs/DigitalMarkJobsNoida";
import TechnicalSupportJobsNoida from "./noidajobs/TechnicalSptJobsNoida";
import AppDevJobsNoida from "./noidajobs/AppDevJobsNoida";
import WebDevelopmentJobsNoida from "./noidajobs/WebDevJobsNoida";
import SoftwareDevelopmentJobsNoida from "./noidajobs/SoftwareDevelopmentJobsNoida";

//Gurugram

import AppDevJobsGurugram from "./gurugramjobs/AppDevJobsGurugram";
import ItJobsGurugram from "./gurugramjobs/ItJobsGurugram";
import JobsInGurugram from "./gurugramjobs/JobsInGurugram";
import HRJobsGurugram from "./gurugramjobs/HRJobsGurugram";
import WebDevJobsGurugram from "./gurugramjobs/WebDevJobsGurugram";
import FresherJobsGurugram from "./gurugramjobs/FresherJobsGurugram";
import FullTimeJobGurugram from "./gurugramjobs/FullTimeJobGurugram";
import TelecallerJobsGurugram from "./gurugramjobs/TelecallerJobsGurugram";
import DigitalMarketingJobsGurugram from "./gurugramjobs/DigitalMarketingJobsGurugram";
import TechnicalSupportJobGuru from "./gurugramjobs/TechnicalSupportJobGuru";
import SoftwareJobsGurugram from "./gurugramjobs/SoftwareJobsGurugram";

//Faridabad

import ItjobsFbd from "./faridabadjobs/ItjobsFbd";
import JobsInFbd from "./faridabadjobs/JobsInFbd";
import HrjobsFbd from "./faridabadjobs/HrjobsFbd";
import FresherjobsFbd from "./faridabadjobs/FresherjobsFbd";
import FulltimejobsFbd from "./faridabadjobs/FulltimejobsFbd";
import TelecallerjobsFbd from "./faridabadjobs/TelecallerjobsFbd";
import DigitalMarketingJobsFbd from "./faridabadjobs/DigitalMarketingJobsFbd";
import TechnicalSupportJobsFbd from "./faridabadjobs/TechnicalSupportJobsFbd";
import AppDevelopmentJobsFbd from "./faridabadjobs/AppDevelopmentJobsFbd";
import WebDevelopmentJobsFbd from "./faridabadjobs/WebDevelopmentJobsFbd";
import SoftwareDevelopmentJobsFbd from "./faridabadjobs/SoftwareDevelopmentJobsFbd";

// Ghaziabad

import ItjobsGhazi from "./ghaziabadjobs/ItjobsGhazi";
import JobsInGhazi from "./ghaziabadjobs/JobsInGhazi";
import HrjobsGhazi from "./ghaziabadjobs/HrjobsGhazi";
import FresherjobsGhazi from "./ghaziabadjobs/FresherjobsGhazi";
import FulltimejobsGhazi from "./ghaziabadjobs/FulltimejobsGhazi";
import TelecallerjobsGhazi from "./ghaziabadjobs/TelecallerjobsGhazi";
import DigitalMarketingJobsGhazi from "./ghaziabadjobs/DigitalMarketingJobsGhazi";
import TechnicalSupportJobsGhazi from "./ghaziabadjobs/TechnicalSupportJobsGhazi";
import AppDevelopmentJobsGhazi from "./ghaziabadjobs/AppDevelopmentJobsGhazi";
import WebDevelopmentJobsGhazi from "./ghaziabadjobs/WebDevelopmentJobsGhazi";
import SoftwareDevelopmentJobsGhazi from "./ghaziabadjobs/SoftwareDevelopmentJobsGhazi";

const App = () => {
  const { currentUser } = useAuth(); // Firebase-authenticated user

  return (
    <Router>
      <ScrollToTop />
      <Toaster richColors position="top-center" />
      {/* <Marquee /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/findjobs" element={<FindJobs />} />
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/companies" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/jobdetails/:id" element={<JobDetailsPage />} />
        <Route path="/applications/:jobId" element={<Resume />} />

        {/* 🔐 Only show admin panel if logged in */}
        <Route
          path="/AdminPannel"
          element={
            currentUser ? <AdminPannel /> : <Navigate to="/AdminLogin" />
          }
        />

        <Route path="/superadmin-login" element={<SuperAdminLogin />} />
        <Route
          path="/superadmin"
          element={
            <SuperAdminRoute>
              <SuperAdmin />
            </SuperAdminRoute>
          }
        />
        <Route
          path="/super-admin/applicants/:companyEmail"
          element={<CompanyApplicants />}
        />
        <Route
          path="/approved-jobs/:jobId/applicants"
          element={<ViewJobApplicants />}
        />
        <Route path="/beourpartner" element={<BeOurPartner />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/jobfair" element={<JobFair />} />
        <Route path="/jobfairs/:slug" element={<JobFairDetails />} />

        {/* KEYWORD PAGES */}

        {/* Keyword of DELHI JOBS  */}
        <Route path="/jobs-in-delhi" element={<JobsInDelhi />} />
        <Route path="/it-jobs-in-delhi" element={<Itjobsdelhi />} />
        <Route path="/hr-jobs-in-Delhi" element={<Hrjobs />} />
        <Route path="/fresher-jobs-in-delhi" element={<Fresherjobs />} />
        <Route path="/fulltime-jobs-in-Delhi" element={<Fulltimejobs />} />
        <Route path="/telecaller-jobs-in-Delhi" element={<Telecallerjobs />} />
        <Route
          path="/digitalmarketing-jobs-in-Delhi"
          element={<DigitalMarketingJobs />}
        />
        <Route
          path="/technicalsupport-jobs-in-Delhi"
          element={<TechnicalSupportJobs />}
        />
        <Route
          path="/appdevelopment-jobs-in-Delhi"
          element={<AppDevelopmentJobs />}
        />
        <Route
          path="/webdevelopment-jobs-in-Delhi"
          element={<WebDevelopmentJobs />}
        />
        <Route
          path="/softwaredevelopment-jobs-in-Delhi"
          element={<SoftwareDevelopmentJobs />}
        />

        {/* Keyword of NOIDA JOBS */}

        <Route path="/it-jobs-in-noida" element={<ItJobs />} />
        <Route path="/jobs-in-noida" element={<JobsInNoida />} />
        <Route path="/hr-jobs-in-noida" element={<HRJobsNoida />} />
        <Route path="/fresher-jobs-in-noida" element={<FresherJobsNoida />} />
        <Route path="/fulltime-jobs-in-noida" element={<FullTimeJobNoida />} />
        <Route
          path="/telecaller-jobs-in-noida"
          element={<TelecallerJobsNoida />}
        />
        <Route
          path="/digitalmarketing-jobs-in-noida"
          element={<DigitalMarketingJobsNoida />}
        />
        <Route
          path="/technicalsupport-jobs-in-noida"
          element={<TechnicalSupportJobsNoida />}
        />
        <Route
          path="/appdevelopment-jobs-in-noida"
          element={<AppDevJobsNoida />}
        />
        <Route
          path="/webdevelopment-jobs-in-noida"
          element={<WebDevelopmentJobsNoida />}
        />
        <Route
          path="/softwaredevelopment-jobs-in-noida"
          element={<SoftwareDevelopmentJobsNoida />}
        />

        {/* Keyword of Gurugram Jobs */}

        <Route path="/it-jobs-in-gurgram" element={<ItJobsGurugram />} />
        <Route path="/jobs-in-gurugram" element={<JobsInGurugram />} />
        <Route path="/hr-jobs-in-gurugram" element={<HRJobsGurugram />} />
        <Route
          path="/fresher-jobs-in-gurugram"
          element={<FresherJobsGurugram />}
        />
        <Route
          path="/fulltime-jobs-in-gurugram"
          element={<FullTimeJobGurugram />}
        />
        <Route
          path="/telecaller-jobs-in-gurugram"
          element={<TelecallerJobsGurugram />}
        />
        <Route
          path="/digitalmarketing-jobs-in-gurugram"
          element={<DigitalMarketingJobsGurugram />}
        />
        <Route
          path="/technicalsupport-jobs-in-gurugram"
          element={<TechnicalSupportJobGuru />}
        />
        <Route
          path="/appdevelopment-jobs-in-gurugram"
          element={<AppDevJobsGurugram />}
        />
        <Route
          path="/webdevelopment-jobs-in-gurugram"
          element={<WebDevJobsGurugram />}
        />
        <Route
          path="/softwaredevelopment-jobs-in-gurugram"
          element={<SoftwareJobsGurugram />}
        />

        {/* Keyword of Faridabad   Jobs */}

        <Route path="/it-jobs-in-faridabad" element={<ItjobsFbd />} />
        <Route path="/jobs-in-faridabad" element={<JobsInFbd />} />
        <Route path="/hr-jobs-in-faridabad" element={<HrjobsFbd />} />
        <Route path="/fresher-jobs-in-faridabad" element={<FresherjobsFbd />} />
        <Route
          path="/fulltime-jobs-in-faridabad"
          element={<FulltimejobsFbd />}
        />
        <Route
          path="/telecaller-jobs-in-faridabad"
          element={<TelecallerjobsFbd />}
        />
        <Route
          path="/digitalmarketing-jobs-in-faridabad"
          element={<DigitalMarketingJobsFbd />}
        />
        <Route
          path="/technicalsupport-jobs-in-faridabad"
          element={<TechnicalSupportJobsFbd />}
        />
        <Route
          path="/appdevelopment-jobs-in-faridabad"
          element={<AppDevelopmentJobsFbd />}
        />
        <Route
          path="/webdevelopment-jobs-in-faridabad"
          element={<WebDevelopmentJobsFbd />}
        />
        <Route
          path="/softwaredevelopment-jobs-in-faridabad"
          element={<SoftwareDevelopmentJobsFbd />}
        />

        {/*  Keyword of Ghaziabad Jobs */}

        <Route path="/it-jobs-in-ghaziabad" element={<ItjobsGhazi />} />
        <Route path="/jobs-in-ghaziabad" element={<JobsInGhazi />} />
        <Route path="/hr-jobs-in-ghaziabad" element={<HrjobsGhazi />} />
        <Route
          path="/fresher-jobs-in-ghaziabad"
          element={<FresherjobsGhazi />}
        />
        <Route
          path="/fulltime-jobs-in-ghaziabad"
          element={<FulltimejobsGhazi />}
        />
        <Route
          path="/telecaller-jobs-in-ghaziabad"
          element={<TelecallerjobsGhazi />}
        />
        <Route
          path="/digitalmarketing-jobs-in-ghaziabad"
          element={<DigitalMarketingJobsGhazi />}
        />
        <Route
          path="/technicalsupport-jobs-in-ghaziabad"
          element={<TechnicalSupportJobsGhazi />}
        />
        <Route
          path="/appdevelopment-jobs-in-ghaziabad"
          element={<AppDevelopmentJobsGhazi />}
        />
        <Route
          path="/webdevelopment-jobs-in-ghaziabad"
          element={<WebDevelopmentJobsGhazi />}
        />
        <Route
          path="/softwaredevelopment-jobs-in-ghaziabad"
          element={<SoftwareDevelopmentJobsGhazi />}
        />
      </Routes>
    </Router>
  );
};

export default App;
